// check picker color
function checkWindowSize() {
  let colorPickerClose = document.querySelector(".farbkategorie.active");
  let colorPickerSearch = document.querySelector(".picker__search_mobile");
  let backNav = document.getElementById("nav-to-previous").innerHTML;

  if (window.innerWidth <= 767 && (colorPickerClose || colorPickerSearch)) {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";

    if (backNav == "Farbliste") {
      document.getElementById("farbemitte").style.display = "none";
      document.getElementById("farbegrrahmen").style.display = "block";
      // console.log("-----give error  group--------");
    } else {
      // console.log("--------give error Farbkategorien-----");
      document.getElementById("farbegrrahmen").style.display = "none";
      document.getElementById("farbemitte").style.display = "block";
    }
  } else {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "none";
    if (backNav == "Farbliste") {
      document.getElementById("farbemitte").style.display = "block";
      document.getElementById("farbegrrahmen").style.display = "block";
      backNav = "Zurück zu Farbkategorien";
    } else {
      document.getElementById("farbemitte").style.display = "block";
      document.getElementById("farbegrrahmen").style.display = "none";
      backNav = "Zurück zu Farbkategorien";
    }
  }
}

window.addEventListener("resize", checkWindowSize);

function backToColorGruppe() {
  var navigation = document.getElementById("nav-to-previous").innerHTML;

  xhide("spezialfarbe");
  xhide("altereimer");
  if (navigation == "Farbliste") {
    // console.log("group cliecked=======");
    xhide("farbegrrahmen");
    document.getElementById("nav-to-previous").innerHTML =
      "Zurück zu Farbkategorien";
    document.getElementById("farbemitte").style.display = "block";
  } else {
    document.getElementById("farbemitte").style.display = "none";
    // console.log("Farbkategorien cliecked=======");
    xhide("farbegrrahmen");
    xhide("farbemitte");

    document
      .querySelector(".color__group__column")
      .classList.remove("picker__mobile");
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "none";

    document.getElementById("search-color-input").value = "";

    document.querySelector("#searchColorCol").style.display = "none";
    document.querySelector("#farbegrrahmen").style.display = "none";
    const farbkategorieElements = document.querySelectorAll(".farbkategorie");
    farbkategorieElements.forEach(function (farbkategorie) {
      farbkategorieElements.forEach(function (el) {
        el.classList.remove("active");
      });
    });
  }
}
function mobile() {
  document
    .querySelector(".color__group__column")
    .classList.add("picker__mobile");
  document
    .querySelector(".color-picker__color-columns")
    .classList.add("picker__mobile");
  if (window.innerWidth <= 767) {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";
  } else {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "none";
  }
}
// show or hide color picker
function showPicker() {
 // ori document.getElementById("site__block").style.top = "-600px";
   document.getElementById("site__block").style.top = "0px";
  document.getElementById("site__block").style.zIndex = "0";
  document.getElementById("previewModal").style.display = "block";
}
function hidePicker() {
  document.getElementById("site__block").style.top = "0px";
  document.getElementById("site__block").style.position = "sticky";
  document.getElementById("site__block").style.zIndex = "1000";
  document.getElementById("search-color-input").value = "";
  document.getElementById("searchColorCol").style.display = "none";
  const modal = document.getElementById("previewModal");
  modal.style.display = "none";
  modal.scrollIntoView({ behavior: "smooth" });
  window.scrollBy({
    top: modal.offsetTop,
    behavior: "smooth",
  });
  hide();
  xhide("farbemitte");
  const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "none";
  document
    .querySelector(".color__group__column")
    .classList.remove("picker__mobile");
  document
    .querySelector("#searchColorCol")
    .classList.remove("picker__search_mobile");
  document
    .querySelector("#searchColorCol")
    .classList.remove("picker__search_mobile");
  const farbkategorieElements = document.querySelectorAll(".farbkategorie");
  farbkategorieElements.forEach(function (farbkategorie) {
    farbkategorieElements.forEach(function (el) {
      el.classList.remove("active");
    });
  });
}

function show(target) {
  document.getElementById(target).style.display = "block";
  document.getElementById("farbemitte").style.display = "block";
  document.getElementById("farbegrrahmen").style.display = "none";
  document.getElementById("farbehw").style.display = "block";
  var element = document.getElementById("farbehw");

  element.clientWidth > 767
    ? (document.getElementById("farbehw").style.display = "block")
    : (document.getElementById("farbehw").style.display = "none");
}
function hide() {
  const elements = document.querySelectorAll("div.colors_list");
  elements.forEach(function (element) {
    element.parentNode.removeChild(element);
  });
  const colorNotFound = colors_col.getElementsByClassName("no_colors_list");
  while (colorNotFound.length > 0) {
    colors_col.removeChild(colorNotFound[0]);
  }
  let existingColorFound =
    colors_col.getElementsByClassName("found_colors_list");
  while (existingColorFound.length > 0) {
    colors_col.removeChild(existingColorFound[0]);
  }
  // hide all color groups preview
  document.getElementById("weiss").style.display = "none";
  document.getElementById("gelb").style.display = "none";
  document.getElementById("orange").style.display = "none";
  document.getElementById("rot").style.display = "none";
  document.getElementById("violett").style.display = "none";
  document.getElementById("gruen").style.display = "none";
  document.getElementById("blau").style.display = "none";
  document.getElementById("grau").style.display = "none";

  document.getElementById("sto2022").style.display = "none";
  document.getElementById("farbegrrahmen").style.display = "none";
  document.getElementById("ral").style.display = "none";
  document.getElementById("dc").style.display = "none";
  document.getElementById("ac").style.display = "none";
  document.getElementById("spezialfarbe").style.display = "none";
  document.getElementById("altereimer").style.display = "none";
  document.getElementById("trendfarben").style.display = "none";
 document.getElementById("lasuren").style.display = "none";
  document.getElementById("db").style.display = "none";
}
function xhide(target) {
  document.getElementById(target).style.display = "none";
}
function scrollToDestination(id) {
  document.getElementById(id).scrollIntoView({ behavior: "smooth" });
}
const farbkategorieElements = document.querySelectorAll(".farbkategorie");

farbkategorieElements.forEach(function (farbkategorie) {
  farbkategorie.addEventListener("click", function () {
    farbkategorieElements.forEach(function (el) {
      el.classList.remove("active");
    });
    farbkategorie.classList.add("active");
    if (window.innerWidth <= 767) {
      const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";
    }
  });
});

// color search
const form = document.getElementById("searchForm");
const initialsInput = document.getElementById("search-color-input");
const searchBtn = document.getElementById("search-color-button");
const resultsDiv = document.getElementById("search-results");
const colors_col = document.querySelector("#searchColorCol");
const picker__group__container = document.getElementById(
  "picker__group__container"
);
// initialsInput.addEventListener("keydown", function () {
//   // console.log(initialsInput.value);
// });
// searchBtn.addEventListener("click", function () {
//   document.querySelector(".c");
// });

picker__group__container &&
  picker__group__container.addEventListener("click", function () {
    document.getElementById("search-color-input").value = "";
  });
function previewColor(name, color, id) {
  document.getElementById("farbegrrahmen").style.display = "block";
  scrollToDestination("farbegr");
  document.getElementById("farbehw").style.display = "none";
  document.getElementById("farbegr").style.backgroundColor = color;
  document.getElementById("waehlenkasten").style.backgroundColor =
    document.getElementById("farbegr").style.backgroundColor;
  // console.log("display color", name, color, id);
  document.getElementById("toenidx").innerHTML = name;
  document.getElementById("toenid").value = id;
  document.getElementById("toenid").innerHTML = id;
}

// end color picker Search

// color picker code

let posibleColor = "//www.farbenbote.de/cdn/shop/files/all-colors.json?v=10294018220202585094";
let notPossibleArticles = "//www.farbenbote.de/cdn/shop/files/not-possible-articles.json?v=1610917277635843501";
let notPossibleColor = "//www.farbenbote.de/cdn/shop/files/not-possible-colorgroups.json?v=13096236686827404850";
let data;
let palette;
let groupsColor = [];
let noColorsList = document.querySelector(".no_colors_list");

document.addEventListener("DOMContentLoaded", function () {
  let product = currentProduct;
  // Get the URL parameter for the variant
  const skus = product.variants.map((variant) => variant.sku);
  // console.log("Variant Skus", skus);
    var colourPreview = document.getElementById("InterneFarben").style.value;
   var colorNameDisplay = document.getElementById("customs-color").value;

  if (colourPreview == "weiß") {
  } else if (colourPreview == "getönt") {
  }

  var variants = product.variants;
  var filteredVariants = [...variants].filter(
    (variant) => variant.option1 == "weiß"
  );

  const objectLength = Object.keys(filteredVariants).length;
  // console.log("====option======", filteredVariants, objectLength);
  if (objectLength > 0) {
    var elementToHide = document.getElementById("hide-white-color");
    elementToHide.style.display = "block";
    colorNameDisplay = "";
  } else {
    var elementToHide = document.getElementById("hide-white-color");
    elementToHide.style.display = "block"; //none
    colorNameDisplay = "weiß";
  }

  // not possible articles
  fetch(notPossibleArticles)
    .then((response) => response.json())
    .then((materialData) => {
      const PossibleMaterial = Array.from(
        new Set(
          materialData
            .filter((sku) => skus.includes(sku.Material) && sku.Maba)
            .map((sku) => {
              // console.log("sku", sku.Material, sku.Maba);
              return sku.Maba;
            })
        )
      );
      // console.log("PossibleMaterial", PossibleMaterial, materialData);
      fetch(notPossibleColor)
        .then((response) => response.json())
        .then((npColorData) => {
          const id_values = npColorData.map((item) => item.Farbton_ID);
          const impossibleColorsArray = npColorData
            .map((color) => {
              if (PossibleMaterial.includes(color.Maba)) {
                return color.Farbton_ID;
              } else {
                return null;
              }
            })
            .filter((colorID) => colorID !== null);
          // console.log("impossibleColorsArray", npColorData);
          let impossibleColors = {};

          impossibleColorsArray.forEach((colorID) => {
            impossibleColors[colorID] = colorID;
            // console.log("impossible: ", impossibleColors[colorID], colorID);
          });

          // console.log("impossible: ", impossibleColors);
          // console.log(impossibleColorsArray);

          fetch(posibleColor)
            .then((response) => response.json())
            .then((data) => {
              // Filter data1 to exclude the colors from file two
              const filteredData = data.filter(
                (item) => item.Farbton_ID !== impossibleColors[item.Farbton_ID]
              );
              // color search
              findSearch(filteredData);

              // console.log("sdds----", filteredData);

              // const filteredData = data.filter(item => !npColorData.map(subItem => subItem.Farbton_ID).includes(item.Farbton_ID));
              // const filteredData = data.filter(item => npColorData.some(subItem => item.Farbton_ID === subItem.Farbton_ID))
              if (data !== undefined) {
                palette = filteredData.map((item) => {
                  return {
                    name: item.Farbtonhilfsbezeichnung,
                    color: `rgb(${item.Rcolor}, ${item.Gcolor}, ${item.Bcolor})`,
                    group: item.Farbton_ID,
                    text: item.L,
                    hbw: item.Y,
                    price: item.Farbtonklasse,
                    vendor: item.Farbtonkarten_Bezeichnung,
                    rColor: item.Rcolor,
                  };
                });
                groupsColor = [...new Set(palette.map((item) => item.group))];
                // console.log("-=-=-groupsColor-=-=-=-=-", groupsColor);
              }
            });
        });
    });
});

// dom manipulation to show color
const container = document.querySelector("#farbemitte");
// clear search

function color_coloumn(
  str1 = undefined,
  str2 = undefined,
  Farbtonkarten_Bezeichnung = undefined
) {
  const elements = document.querySelectorAll("div.colors_list");
  document.getElementById("nav-to-previous").innerHTML =
    "Zurück zu Farbkategorien";

  elements.forEach(function (element) {
    element.parentNode.removeChild(element);
  });
  const colorNotFound = colors_col.getElementsByClassName("no_colors_list");
  while (colorNotFound.length > 0) {
    colors_col.removeChild(colorNotFound[0]);
  }
  let existingColorFound =
    colors_col.getElementsByClassName("found_colors_list");
  while (existingColorFound.length > 0) {
    colors_col.removeChild(existingColorFound[0]);
  }
  document.getElementById("search-color-input").value = "";
  //end clear search

  palette.forEach((item) => {
    let str;
    if (Farbtonkarten_Bezeichnung) str = item.vendor;
    else if (str1 && str2) {
      str = item.group;
    }
    if (
      (item.rColor && Farbtonkarten_Bezeichnung == str) ||
      (item.rColor &&
        str1 &&
        str2 &&
        (str.startsWith(str1, 0) || str.startsWith(str2, 0)))
    ) {
      const div = document.createElement("div");
      div.classList.add("colors_list");
      div.style.backgroundColor = item.color;
      div.style.cursor = "pointer";
      div.style.width = "100%";
      div.style.height = "60px";
      div.style.display = "flex";
      div.style.justifyContent = "center";
      div.style.alignItems = "center";
      div.style.color = item.text < 50 ? `rgb(255,255,255)` : `rgb(0,0,0)`;
      div.style.fontSize = "20px";
     div.textContent = item.group+ "  "+item.name;
     // div.textContent = item.group;
      div.addEventListener("click", () => {
        displayColor(item.name, item.color, item.group);
      });

      container.appendChild(div);

      // console.log("testing", str);
    }
  });
  document
    .querySelector(".color__group__column")
    .classList.add("picker__mobile");
  document
    .querySelector(".color-picker__color-columns")
    .classList.add("picker__mobile");
  if (window.innerWidth <= 767) {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";
  } else {
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "none";
  }
}
function displayColor(name, color, id) {
  document.getElementById("farbegrrahmen").style.display = "block";
  document.getElementById("nav-to-previous").innerHTML = "Farbliste";

  if (window.innerWidth <= 767) {
    document.getElementById("farbemitte").style.display = "none";
    const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";
  }
  scrollToDestination("farbegr");
  document.getElementById("farbehw").style.display = "none";
  document.getElementById("farbegr").style.backgroundColor = color;
  document.getElementById("waehlenkasten").style.backgroundColor =
    document.getElementById("farbegr").style.backgroundColor;
  // console.log("display color", name, color, id);
  document.getElementById("toenidx").innerHTML = name;
  document.getElementById("toenid").value = id;
  document.getElementById("toenid").innerHTML = id;
  let currentVariantUrl = window.location.href;
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set("color", id);
  window.history.pushState(
    { path: currentVariantUrl },
    "",
    `${currentVariantUrl.split("?")[0]}?${searchParams.toString()}`
  );
}

// Search color function
function findSearch(data) {
  form.addEventListener("submit", (event) => {
    event.preventDefault(); // prevent the page from refreshing
    document
      .querySelector("#searchColorCol")
      .classList.add("picker__search_mobile");
    document
      .querySelector(".color__group__column")
      .classList.add("picker__mobile");

    if (window.innerWidth <= 767) {
      const closeBtn = document.querySelector(".color-picker__close");
if (closeBtn) closeBtn.style.display = "flex";
    }
    const initials = initialsInput.value.toUpperCase();

    const filteredData = data.filter((item) =>
      item.Farbton_ID.includes(initials)
    );

    if (filteredData.length > 0) {
      !colors_col.classList.contains("col-md-8") &&
        colors_col.classList.add("col-md-8");
      const existingColorNotFound =
        colors_col.getElementsByClassName("no_colors_list");
      while (existingColorNotFound.length > 0) {
        colors_col.removeChild(existingColorNotFound[0]);
      }
      const existingColorFound =
        colors_col.getElementsByClassName("found_colors_list");
      while (existingColorFound.length > 0) {
        colors_col.removeChild(existingColorFound[0]);
      }
      const coloFound = document.createElement("div");
      coloFound.classList.add("found_colors_list");
      coloFound.style.width = "100%";
      coloFound.style.height = "40px";
      coloFound.style.margin = "10px";
      coloFound.style.padding = "10px";
      coloFound.style.display = "flex";
      coloFound.style.justifyContent = "flex-start";
      coloFound.style.fontSize = "18px";
      coloFound.textContent = `Farbe ${initialsInput.value} gefunden:`;
      colors_col.appendChild(coloFound);

      filteredData.forEach((item) => {
        const colorList = document.createElement("div");
        // colorList += `<p style="padding:20px 30px;background-color:rgb(${item.Rcolor},${item.Gcolor},${item.Bcolor})">${item.Farbton_ID}</p>`;
        colorList.classList.add("colors_list");
        colorList.style.backgroundColor = `rgb(${item.Rcolor},${item.Gcolor},${item.Bcolor})`;
        colorList.style.cursor = "pointer";
        colorList.style.width = "100%";
        colorList.style.height = "60px";
        // colorList.style.margin = "10px";
        // colorList.style.padding = "10px";
        colorList.style.display = "flex";
        colorList.style.justifyContent = "center";
        colorList.style.alignItems = "center";
        colorList.style.color = item.L < 50 ? `rgb(255,255,255)` : `rgb(0,0,0)`;
        colorList.style.fontSize = "20px";
        colorList.textContent = item.Farbton_ID+" - "+item.Farbtonhilfsbezeichnung;
        colorList.addEventListener("click", () => {
          previewColor(
            item.Farbtonhilfsbezeichnung, 
            `rgb(${item.Rcolor}, ${item.Gcolor}, ${item.Bcolor})`,
            item.Farbton_ID
          );
        });
        colors_col.appendChild(colorList);
      });
    } else {
      const colorNotFound = document.createElement("div");
      const existingColorNotFound =
        colors_col.getElementsByClassName("no_colors_list");
      while (existingColorNotFound.length > 0) {
        colors_col.removeChild(existingColorNotFound[0]);
      }
      let existingColorFound =
        colors_col.getElementsByClassName("found_colors_list");
      while (existingColorFound.length > 0) {
        colors_col.removeChild(existingColorFound[0]);
      }
      colors_col.classList.contains("col-md-8") &&
        colors_col.classList.remove("col-md-8");

      colorNotFound.classList.add("no_colors_list");
      colorNotFound.style.width = "100%";
      colorNotFound.style.height = "75px";
      colorNotFound.style.margin = "10px";
      colorNotFound.style.padding = "10px";
      colorNotFound.style.display = "flex";
      colorNotFound.style.justifyContent = "flex-start";
      colorNotFound.style.color = `rgb(255,255,255)`;
      colorNotFound.style.fontSize = "18px";
      colorNotFound.textContent = `Farbe ${initialsInput.value} nicht gefunden`; 
      colors_col.appendChild(colorNotFound);
    }
  });
}
